import { computed, Injectable, signal } from '@angular/core'
import { OrdersService } from '../orders.service'
import { HttpErrorResponse } from '@angular/common/http'
import { OrderCounters } from '../models/order-listing.model'

interface OrdersCountersState {
  counters?: OrderCounters
  isLoading: boolean
  error?: HttpErrorResponse
}

const COUNTERS_INITIAL_STATE: OrdersCountersState = {
  isLoading: false,
}

@Injectable()
export class OrdersCountersStore {
  constructor(private ordersService: OrdersService) {}

  private state = signal<OrdersCountersState>(COUNTERS_INITIAL_STATE)

  // Selectors
  readonly counters = computed(() => this.state().counters)
  readonly isLoading = computed(() => this.state().isLoading)

  // Effects

  async load(): Promise<void> {
    this.unsetError()

    return new Promise((resolve, reject) => {
      this.ordersService.counts$().subscribe({
        next: async (data) => {
          resolve()
          this.setData(data)
        },
        error: (error) => {
          reject(error)
          this.setError(error)
        },
      })
    })
  }

  // Reducers

  setData(counters: OrderCounters) {
    this.state.set({
      ...this.state(),
      counters,
      isLoading: false,
      error: undefined,
    })
  }

  setIsLoading(isLoading: boolean) {
    this.state.set({ ...this.state(), isLoading })
  }

  setError(error: HttpErrorResponse) {
    this.state.set({ ...this.state(), isLoading: false, error })
  }

  unsetError() {
    this.state.set({ ...this.state(), isLoading: true, error: undefined })
  }
}
